/**
 * Ambiente da app para separar homolog e produção no PostHog (super property `ambiente`).
 *
 * Homolog e produção rodam o mesmo `vite build`, então `import.meta.env.MODE` é `production` nos dois.
 * Ordem: `VITE_APP_ENV` (se for um valor válido) → host do `VITE_ARIDE_API_URL` → `desconhecido`.
 * Nunca cai em `producao` por padrão. Módulo puro (sem `import.meta`) para ser testável no Jest.
 */
export type AppEnv = 'development' | 'homolog' | 'producao' | 'desconhecido';

const EXPLICIT_ENVS: AppEnv[] = ['development', 'homolog', 'producao'];
const PRODUCTION_API_HOST = 'api.aride.com.br';
const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

function envFromApiUrl(apiUrl: string): AppEnv {
  let host: string;
  try {
    host = new URL(apiUrl).hostname.toLowerCase();
  } catch {
    return 'desconhecido';
  }
  if (host.includes('homolog')) return 'homolog';
  if (host === PRODUCTION_API_HOST) return 'producao';
  if (LOCAL_HOSTS.includes(host)) return 'development';
  return 'desconhecido';
}

export function resolveAppEnv({ appEnv, apiUrl }: { appEnv?: string; apiUrl?: string }): AppEnv {
  const explicit = String(appEnv ?? '')
    .trim()
    .toLowerCase() as AppEnv;
  if (EXPLICIT_ENVS.includes(explicit)) return explicit;
  return envFromApiUrl(String(apiUrl ?? '').trim());
}
